var React = require('react');

function PowerButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.487 1.5C25.487.672 24.82 0 24 0c-.821 0-1.487.672-1.487 1.5v21.094c0 .828.666 1.5 1.487 1.5.821 0 1.487-.672 1.487-1.5V1.5zm-8 8.43a1.504 1.504 0 00.85-1.94 1.483 1.483 0 00-1.924-.857A21.14 21.14 0 003 26.843C3 38.526 12.403 48 24 48c11.595 0 21-9.474 21-21.157a21.14 21.14 0 00-13.413-19.71 1.483 1.483 0 00-1.923.857 1.504 1.504 0 00.849 1.94 18.14 18.14 0 0111.514 16.913C42.027 36.865 33.957 45 24 45c-9.959 0-18.027-8.134-18.027-18.157A18.14 18.14 0 0117.487 9.93z"}));
}

PowerButton.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PowerButton;

PowerButton.default = PowerButton;
